// UI-only configuration for the messaging redesign (candidate side).
// Status values here are display-only and are NOT wired to backend fields yet.

export type ApplicationStatus =
    | "pending"
    | "in_review"
    | "interview"
    | "accepted"
    | "rejected";

export interface StatusConfig {
    label: string;
    color: string;
    bg: string;
}

export const STATUS_CONFIG: Record<ApplicationStatus, StatusConfig> = {
    pending: {label: "Gesendet", color: "#8c8c8c", bg: "#fafafa"},
    in_review: {label: "In Prüfung", color: "#1677ff", bg: "#e6f4ff"},
    interview: {label: "Gespräch", color: "#722ed1", bg: "#f9f0ff"},
    accepted: {label: "Angenommen", color: "#52c41a", bg: "#f6ffed"},
    rejected: {label: "Abgelehnt", color: "#ff4d4f", bg: "#fff2f0"},
};

export const STATUS_TABS: {key: ApplicationStatus | "all"; label: string}[] = [
    {key: "all", label: "Alle"},
    {key: "pending", label: "Gesendet"},
    {key: "in_review", label: "In Prüfung"},
    {key: "interview", label: "Gespräch"},
    {key: "accepted", label: "Angenommen"},
    {key: "rejected", label: "Abgelehnt"},
];

export const getInitials = (name?: string): string => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
